import { StreamParser } from '../ai-stream-parser/StreamParser';
import { set } from 'lodash';
import { PATH_PREFIX } from '@/config/constant';
import { getTraceIdHeaders, AI_MODULE_MAP } from '@/modules/ai/helper';
import OpenAI from 'openai';
import { createWujiAI } from '@tencent/wuji-utils';
let openai = null;
function getOpenAiInstance(options) {
    let projectId = '';
    let env = 'dev';
    if (window?.RUNTIME_CONFIGS) {
        ({ projectId, env } = window.RUNTIME_CONFIGS);
    }
    else {
        const query = new URLSearchParams(window.location.search);
        projectId = query.get('projectId') || query.get('projectid') || '';
    }
    if (!projectId || !env)
        return;
    const clientOptions = {
        apiKey: '',
        baseURL: `${window.location.origin}${PATH_PREFIX}/api/xy/runtime/llm`,
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            'xy-project-id': projectId,
            'xy-env': env,
            ...getTraceIdHeaders(AI_MODULE_MAP.RUNTIME_AI_SDK),
        },
    };
    if (options?.apiKey)
        set(clientOptions, ['defaultHeaders', 'xy-ai-api-key'], options.apiKey);
    if (options?.baseURL)
        set(clientOptions, ['defaultHeaders', 'xy-ai-base-url'], options.baseURL);
    return new OpenAI(clientOptions);
}
function initByImport(options) {
    openai = getOpenAiInstance(options);
}
function initByPlugin() {
    const config = window['internal:w-plugin-openai:config'];
    if (config) {
        openai = getOpenAiInstance(config);
    }
}
class BrowserOpenAIClientProvider {
    getClient() {
        if (!openai)
            initByPlugin();
        if (!openai)
            initByImport();
        return openai;
    }
}
const browserProvider = new BrowserOpenAIClientProvider();
export const wujiAI = createWujiAI(() => browserProvider);
export function getLLMInstance() {
    return new Proxy({}, {
        get(target, prop) {
            if (prop === 'init') {
                return (options) => initByImport(options);
            }
            if (prop === 'StreamParser') {
                return StreamParser;
            }
            return wujiAI[prop];
        },
    });
}
